// extracted by mini-css-extract-plugin
module.exports = {"categories":"CategoriesBoats_categories__24i2r","slide":"CategoriesBoats_slide__240OZ","category":"CategoriesBoats_category__1Pznd","name":"CategoriesBoats_name__3UYXj"};